/**
 * Temperature conversion utilities.
 *
 * The backend currently emits all temperature values in Celsius (skin_temp,
 * body temperature, deviations from baseline). The UI displays everything in
 * Fahrenheit until a future settings-driven imperial/metric toggle is added.
 *
 * Two conversion modes:
 *   - Absolute: F = C * 9/5 + 32  (e.g., 34.2°C → 93.6°F)
 *   - Delta:    F = C * 9/5       (e.g., 0.3°C deviation → 0.54°F deviation)
 */

export function celsiusToFahrenheit(celsius: number): number {
  return celsius * 9 / 5 + 32;
}

export function celsiusDeltaToFahrenheit(celsiusDelta: number): number {
  return celsiusDelta * 9 / 5;
}
